import { useState } from "react";

const defaultState = {
  result: null,
  isFetching: false,
  error: null
};

function useFetch(fetchFunc) {
  const [status, setStatus] = useState(defaultState);

  // Returns the result (or `undefined` on error) so callers can also
  // `await invoke()` and read the payload inline, without waiting a render
  // for the tuple `result` to update. Existing callers that ignore the
  // return value keep working — they still read from the tuple. Errors are
  // swallowed (surfaced via the tuple's `error`) to preserve the original
  // contract; a caller that wants to throw can inspect `error` after the
  // await.
  const invoke = async (...data) => {
    setStatus({
      error: null,
      result: null,
      isFetching: true
    });
    try {
      const result = await fetchFunc(...data);
      setStatus({
        result,
        isFetching: false,
        error: null
      });
      return result;
    } catch (error) {
      setStatus({
        result: null,
        isFetching: false,
        error: error.message
      });
      return undefined;
    }
  };

  const reset = () => setStatus(defaultState);

  return [invoke, status.result, status.isFetching, status.error, reset];
}

export { useFetch };
